export const ICONS_VERSION = "1717151959483";
export const ICON_SPRITE = "/icons-generated/_icon-sprite.svg";
